(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-category-slider"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('cs-slider')) {
    class CsSlider extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-cs-track]');
        this.prevBtn = this.querySelector('[data-cs-prev]');
        this.nextBtn = this.querySelector('[data-cs-next]');
        if (!this.track) return;

        this.loop = this.dataset.loop === 'true';
        this.scrollMode = this.dataset.scrollBy || 'item';
        this.delay = Math.max(2, parseFloat(this.dataset.delay) || 4) * 1000;
        this.autoplay =
          this.dataset.autoplay === 'true' &&
          !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.timer = null;
        this.moved = false;
        this.raf = null;

        this.onPrev = () => this.go(-1);
        this.onNext = () => this.go(1);
        this.onScroll = () => {
          if (this.raf) return;
          this.raf = requestAnimationFrame(() => {
            this.raf = null;
            this.update();
          });
        };

        /* mouse drag (touch uses native scrolling) */
        this.onMouseDown = (e) => {
          if (e.button !== 0) return;
          this.moved = false;
          this.startX = e.pageX;
          this.startLeft = this.track.scrollLeft;
          document.addEventListener('mousemove', this.onMouseMove);
          document.addEventListener('mouseup', this.onMouseUp);
        };
        this.onMouseMove = (e) => {
          const dx = e.pageX - this.startX;
          if (!this.moved && Math.abs(dx) > 5) {
            this.moved = true;
            this.track.classList.add('is-dragging');
          }
          if (this.moved) {
            e.preventDefault();
            this.track.scrollLeft = this.startLeft - dx;
          }
        };
        this.onMouseUp = () => {
          document.removeEventListener('mousemove', this.onMouseMove);
          document.removeEventListener('mouseup', this.onMouseUp);
          this.track.classList.remove('is-dragging');
          setTimeout(() => { this.moved = false; }, 0);
        };
        this.onClickCapture = (e) => {
          if (this.moved) {
            e.preventDefault();
            e.stopPropagation();
          }
        };

        /* autoplay pause / resume */
        this.onEnter = () => this.stop();
        this.onLeave = () => this.start();
        this.onVisibility = () => (document.hidden ? this.stop() : this.start());

        if (this.prevBtn) this.prevBtn.addEventListener('click', this.onPrev);
        if (this.nextBtn) this.nextBtn.addEventListener('click', this.onNext);
        this.track.addEventListener('scroll', this.onScroll, { passive: true });
        this.track.addEventListener('mousedown', this.onMouseDown);
        this.track.addEventListener('click', this.onClickCapture, true);

        if (this.autoplay) {
          this.addEventListener('mouseenter', this.onEnter);
          this.addEventListener('mouseleave', this.onLeave);
          this.addEventListener('focusin', this.onEnter);
          this.addEventListener('focusout', this.onLeave);
          document.addEventListener('visibilitychange', this.onVisibility);
        }

        if ('ResizeObserver' in window) {
          this.resizeObserver = new ResizeObserver(() => this.update());
          this.resizeObserver.observe(this.track);
        } else {
          window.addEventListener('resize', this.onScroll);
        }

        this.update();
        this.start();
      }

      disconnectedCallback() {
        this.stop();
        if (this.raf) cancelAnimationFrame(this.raf);
        if (this.resizeObserver) this.resizeObserver.disconnect();
        window.removeEventListener('resize', this.onScroll);
        document.removeEventListener('visibilitychange', this.onVisibility);
        document.removeEventListener('mousemove', this.onMouseMove);
        document.removeEventListener('mouseup', this.onMouseUp);
      }

      get maxScroll() {
        return this.track.scrollWidth - this.track.clientWidth;
      }

      step() {
        const first = this.track.firstElementChild;
        if (!first) return this.track.clientWidth;
        const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
        const itemW = first.getBoundingClientRect().width + gap;
        if (this.scrollMode === 'page') {
          const n = Math.max(1, Math.floor(this.track.clientWidth / itemW + 0.01));
          return itemW * n;
        }
        return itemW;
      }

      go(dir, auto = false) {
        const t = this.track;
        const wrap = this.loop || auto;
        const max = this.maxScroll;
        if (max <= 2) return;

        if (dir > 0) {
          if (t.scrollLeft >= max - 2) {
            if (wrap) t.scrollTo({ left: 0, behavior: 'smooth' });
            return;
          }
          t.scrollBy({ left: this.step(), behavior: 'smooth' });
        } else {
          if (t.scrollLeft <= 2) {
            if (wrap) t.scrollTo({ left: max, behavior: 'smooth' });
            return;
          }
          t.scrollBy({ left: -this.step(), behavior: 'smooth' });
        }
      }

      update() {
        const max = this.maxScroll;
        const left = this.track.scrollLeft;
        this.classList.toggle('is-static', max <= 2);
        if (this.prevBtn) this.prevBtn.disabled = !this.loop && left <= 2;
        if (this.nextBtn) this.nextBtn.disabled = !this.loop && left >= max - 2;
      }

      start() {
        if (!this.autoplay) return;
        this.stop();
        this.timer = setInterval(() => this.go(1, true), this.delay);
      }

      stop() {
        if (this.timer) {
          clearInterval(this.timer);
          this.timer = null;
        }
      }
    }
    customElements.define('cs-slider', CsSlider);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  

  } catch(e) { console.error(e); }
})();
})();
